import React from "react";
import { useNavigate } from "react-router-dom";
import "../Categorias/Categorias.css";
import delice from "../../../assets/Categorias/delice.png";
import untadeli from "../../../assets/Categorias/untadeli.png";
import delichizz from "../../../assets/Categorias/delichizz.png";
import frico from "../../../assets/Categorias/frico.png";

const categorias = [
  { image: delice, text: "Delice" },
  { image: delichizz, text: "Delichizz" },
  { image: untadeli, text: "Untadeli" },
  { image: frico, text: "Frico" },
];

const Categorias = () => {
  const navigate = useNavigate();

  const handleCategoriaClick = (nombre) => {
    navigate(`/categoria/${nombre}`);
  };

  return (
    <div className="categorias-grid">
      {categorias.map((categoria, index) => (
        <div
          className="categoria-container"
          key={index}
          onClick={() => handleCategoriaClick(categoria.text)}
        >
          <img
            src={categoria.image}
            alt={`Categoría ${categoria.text}`}
            className="categoria-image"
          />
          <div className="categoria-overlay">
            <span>{categoria.text}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Categorias;
